// extracted by mini-css-extract-plugin
export default {"centre":"map-annual-running-cost_centre__3OKdR","hiddenARC":"map-annual-running-cost_hiddenARC__n9tmH"};